import type { RouteLocationNormalized } from 'vue-router'
import { instanceQueryService } from '@/services'

// Abort the prior requests on route change.
export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const instance = to?.instance_id || to?.params?.instance_id || to?.instance || to?.params?.instance
  const instanceFrom = from?.instance_id || from?.params?.instance_id || from?.instance || from?.params?.instance
  instanceQueryService.abortActiveRequests(instance, instanceFrom)
})
